import React from 'react'

import collapsed from './../../../UI/general/collapse.svg'
import close from "./../../../UI/general/close.svg"
import next from "./../../../UI/general/Next-Asset.svg"

import gallery from "./../../../UI/Modal/gallery.svg"

interface Props {
    isVirtualTourActive: boolean,
    amenityData: any,
    handleCloseVirtualTour: any,
    colorsData: any,
    galleryName: string,
    breadCrumbs: any,
    handleGetBreadCrumbSelected: any,
    comesFromModalGallery: boolean
}

interface State {
    isCollapsed: boolean,
    currentSelectedTour: string,
    currentSelectedtourIndex: number,
    rgbaColor: any,
    currentHoverSelected: number,
    show: boolean
}

class DetailedTour extends React.Component<Props,State>{

    constructor(props: Props){
        super(props);
        this.state = {
            isCollapsed: !this.props.comesFromModalGallery,
            currentSelectedTour: "",
            currentSelectedtourIndex: 0,
            rgbaColor: {},
            currentHoverSelected: -1,
            show: false
        }
    }

    componentDidMount(): void {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(this.props.colorsData.main_buttons)
        this.setState({
          rgbaColor: result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
          } : ""
        })
        if(this.state.isCollapsed){
            setTimeout(() => {
                this.setState({
                    isCollapsed: false
                })
            },500)
        }
        this.setState({
            show: true,
            currentSelectedTour: this.props.amenityData.links[0].link,
        })
    }

    componentDidUpdate = (prevProps: any) => {
        if(this.props.breadCrumbs !== prevProps.breadCrumbs){
            this.setState({
                isCollapsed: false
            })
        }
        if(prevProps.isVirtualTourActive !== this.props.isVirtualTourActive && this.props.isVirtualTourActive === true){
            this.setState({
                currentSelectedTour: this.props.amenityData.links[0].link,
                isCollapsed: this.props.breadCrumbs.length === 0
            }, () => {
                if(this.state.isCollapsed){
                    setTimeout(() => {
                        this.setState({
                            isCollapsed: false
                        })
                    },500)
                }
            })
        }
    }

    handleChangeTour = (tour: any, index: number) => {
        this.setState({
            currentSelectedTour: tour,
            currentSelectedtourIndex: index
        })
    }

    render(): React.ReactNode {
        return(
            <div className={this.state.show ? 'detailed-tour-container fade-in':'detailed-tour-container fade-out'}>
                {
                    this.props.isVirtualTourActive ? 
                    <div className={this.state.isCollapsed ?'frame-container-wide':'frame-container'}>
                        <div className='iframe-container'>
                            <iframe src={this.state.currentSelectedTour} title="virtual-tours" width={"100%"} height="100%" style={{border: "none"}}/>
                        </div>
                    </div>:null
                }
                <div 
                    className={this.state.isCollapsed ? 'sidebar-tour-btn-collapsed':'sidebar-tour-btn'}
                    onClick = {() => {
                        this.setState({
                            isCollapsed: !this.state.isCollapsed
                        })
                    }}
                >
                    <img src={collapsed} alt=""/>
                </div>
                <div className={this.state.isCollapsed ? 'sidebar-tour-container-collapsed':'sidebar-tour-container'}>
                <div 
                    className="general-gallery-close-container"
                    onClick={() => {
                        this.setState({
                            isCollapsed: true
                        })
                        setTimeout(() => {
                            this.props.handleCloseVirtualTour()
                        }, 500) 
                    }}
                >
                    <img src={close} alt=''/>
                </div>
                {
                    this.props.galleryName !== '' && this.props.breadCrumbs.length === 0 ?
                    <div className='gallery-modal-name'
                    onClick={this.props.breadCrumbs.length > 0 ?
                        () => {
                            this.props.handleGetBreadCrumbSelected(-2)
                        }:() => {}
                    }
                    style={{
                        cursor: this.props.breadCrumbs.length > 0 ? 'pointer':'inherit'
                    }}
                    >{this.props.breadCrumbs.length > 0 ? 'Galería':this.props.galleryName}</div>:null
                }
                {
                    this.props.galleryName !== '' && this.props.breadCrumbs.length > 0 ?
                    <React.Fragment>
                        <div className='general-gallery-img-icon-container'>
                            <img src={gallery} alt=''/>
                        </div>
                        <div className='galerry-name-desktop'>GALERÍA</div>
                    </React.Fragment>:null
                }
                {
                    this.props.breadCrumbs.length > 0 ?
                    <div className='breadcrumbs-gallery-modal-container-desktop'>
                        <div className='breadcrumb' onClick={() => {
                            this.props.handleGetBreadCrumbSelected(-2)
                        }}>Galería</div>
                        {
                            this.props.breadCrumbs.map((breadCrumb :any, index: number) => 
                                <React.Fragment>
                                    <img src={next} alt=''/>
                                    <div 
                                    className={index === this.props.breadCrumbs.length - 1 ? 'last-breadcrumb':'breadcrumb'}
                                    onClick={index === this.props.breadCrumbs.length -1 ? () => {}:() => {
                                        this.props.handleGetBreadCrumbSelected(index)
                                    }}
                                    style={{
                                        animation: index === this.props.breadCrumbs.length -1 ? 'moveLeftAlt 0.4s ease-in-out 1':'none',
                                        backgroundColor: index === this.props.breadCrumbs.length -1 ? this.props.colorsData.main_buttons:'none'
                                    }}
                                    >
                                        {breadCrumb}
                                    </div>
                                </React.Fragment>
                            )
                        }
                    </div>:null
                }
                    <div className='sidebar-tour-preview-container-brochures' style={{
                        top: this.props.breadCrumbs.length > 0 ? '23%':'10%', 
                        height: this.props.breadCrumbs.length > 0 ? '77%':'90%',
                        animation: 'moveLeft 1s ease-in-out 1'
                        }}>
                        {
                            this.props.amenityData && this.props.amenityData.links ?
                            this.props.amenityData.links.map((tours: any, index: number) => 
                                <div 
                                    key = {tours.name + index}
                                    className='individual-tour-container-alt'
                                    onClick = {() => {
                                        this.handleChangeTour(tours.link, index)
                                    }}
                                    style={{
                                        boxSizing: 'border-box',
                                        backgroundColor: this.state.currentSelectedtourIndex === index ? this.props.colorsData.main_buttons:'transparent',
                                        color: this.state.currentSelectedtourIndex === index ? this.props.colorsData.secondary_text:this.props.colorsData.main_text
                                    }}
                                >
                                    <div 
                                        className='individual-tour-name-container-alt'
                                    >
                                        {tours.name}
                                    </div>
                                </div>
                            ):null
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default DetailedTour